import filtermenu from "./includes/filter-menu";
import mobilesearch from "./includes/mobile-search";

/**
 * Vanilla JS functions.
 */
function debounce(func, wait, immediate) {
    var timeout;
    return function () {
        var context = this,
            args = arguments;
        var later = function () {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
}

document.addEventListener("DOMContentLoaded", () => {
    var prevScrollpos = window.pageYOffset;
    var banner = document.getElementById("content-block-notification-banner");
    var navbar = document.getElementById("navbar");
    if (navbar) {
        window.onscroll = function () {
            var currentScrollPos = window.pageYOffset;
            if (prevScrollpos > currentScrollPos || currentScrollPos < 50) {
                navbar.style.top = "0";

                if (banner) {
                    if (window.innerWidth < 768) {
                        banner.style.top = "48px";
                    } else {
                        banner.style.top = "84px";
                    }
                }
            } else {
                navbar.style.top = "-100px";
                if (banner) {
                    banner.style.top = "0";
                }
            }
            prevScrollpos = currentScrollPos;
        };
    }

    document.addEventListener("click", event => {
        const clickedId = event.target.id;
        const miniBasket = document.getElementById("mini-basket");
        const openAccountMobile = document.querySelector(".login-tooltip");
        if (clickedId) {
            // if (
            //     clickedId == "toggle-basket-wrapper" ||
            //     clickedId == "toggle-basket-text"
            // ) {
            //     if (miniBasket.classList.contains("d-none")) {
            //         miniBasket.classList.remove("d-none");
            //     }
            //     return;
            // }

            if (clickedId == "openAccountMobile") {
                // If openAccountMobile do nothing. Open logic below.
                return;
            }
        }

        if (miniBasket && (clickedId != 'toggle-basket-wrapper' && clickedId != 'toggle-basket-text')) {
            if (!miniBasket.classList.contains("d-none")) {
                miniBasket.classList.add("d-none");
                window.app.showMiniBasket = false;
            }
        }

        // Close the Login tooltip (openAccountMobile)
        if (openAccountMobile) {
            if (!openAccountMobile.classList.contains("closed")) {
                openAccountMobile.classList.add("closed");
            }
        }
    });

    var clickedAnchor = document.getElementsByTagName('a');

    for (var i = 0; i < clickedAnchor.length; i++) {
        if (clickedAnchor[i].className == 'show-more') {
            clickedAnchor[i].addEventListener('click', function (event) {
                event.preventDefault();
                var parentDiv = this.parentElement;
                var btnChildren = this.getElementsByTagName("span");

                if (parentDiv.children[0].className.match(/hideContent/g)) {
                    parentDiv.children[0].className = 'content showContent';
                    btnChildren[0].innerHTML = 'Read Less';
                    this.classList.add('contentShown');
                } else {
                    parentDiv.children[0].className = 'content hideContent';
                    btnChildren[0].innerHTML = 'Read More';
                    this.classList.remove('contentShown');
                }
            });
        } else if (clickedAnchor[i].className == 'member-read-more') {
            clickedAnchor[i].addEventListener('click', function (event) {
                event.preventDefault();
                var memberCard = this.parentElement.parentElement;
                var btnChildren = this.getElementsByTagName("span");

                if (memberCard.className.match(/showBack/g)) {
                    memberCard.classList.remove('showBack');
                    btnChildren[0].innerHTML = 'Read More';
                } else {
                    memberCard.classList.add('showBack');
                    btnChildren[0].innerHTML = 'Read Less';
                }
            });
        }

    }

    const cardFlipper = document.querySelectorAll(".card-flipper");
    cardFlipper.forEach(el => {
        el.addEventListener("click", () => {
            const cardClicked = el.dataset.card;
            console.log("click", cardClicked);
            flipCard(cardClicked);
        });
    });

    const schoolMobilePagination = document.querySelectorAll(
        ".schoolMobilePagination"
    );

    schoolMobilePagination.forEach(el => {
        el.addEventListener("change", () => {
            const slug = window.location.pathname.substring(1).split("/");
            const changedValue = el.value;

            console.log(changedValue, slug[1]);

            if (slug[1] !== changedValue) {
                window.location.href = "/school-finder/" + changedValue;
            }
        });
    });

    if (!Cookies.get("notification_banner")) {
        const notificationBanner = document.querySelectorAll(
            ".notification-banner"
        );

        notificationBanner.forEach(el => {
            el.classList.remove("d-none");
            el.classList.add("d-block");

            el.querySelector("button").addEventListener("click", () => {
                Cookies.set("notification_banner", true, {
                    expires: 1
                });

                el.classList.remove("d-block");
                el.classList.add("d-none");
            });
        });
    }

    //TODO: Serious lack of DRY going on here.

    var menutrigger = document.getElementById('menu-trigger');
    const menu = document.querySelectorAll(".menu");

    menu.forEach(el => {
        el.addEventListener("click", e => {
            e.preventDefault();
            const megaNavWrapperLogin = document.querySelector(
                ".login-tooltip"
            );
            const megaNavWrapperContact = document.querySelector(
                ".contact-tooltip"
            );
            const megaNavWrapperAccount = document.querySelector(
                ".meganav-wrapper.account-meganav"
            );
            const megaNavWrapperMain = document.querySelector(
                ".meganav-wrapper.main-nav"
            );
            const megaNavWrapperUniform = document.querySelector(
                ".meganav-wrapper.uniform-meganav"
            );
            const megaNavWrapperMoreinfo = document.querySelector(
                ".meganav-wrapper.more-info-nav"
            );

            if(megaNavWrapperLogin) {
                megaNavWrapperLogin.classList.add("closed");
            }

            megaNavWrapperContact.classList.add("closed");
            megaNavWrapperAccount.classList.add("closed");
            megaNavWrapperUniform.classList.add("closed");
            megaNavWrapperMoreinfo.classList.add("closed");

            el.classList.toggle("menu-open");

            menutrigger.classList.toggle('active');

            if (megaNavWrapperMain.classList.contains('closed')) {
                document.querySelector("body").classList.add("noScroll");
            }

            megaNavWrapperMain.classList.toggle("closed");
            if (megaNavWrapperMain.classList.contains('closed')) {
                menutrigger.classList.remove('active');
            } else {
                menutrigger.classList.add('active');
            }
        });
    });

    const uniformMenu = document.getElementById("uniformMenu");
    if (uniformMenu) {
        uniformMenu.addEventListener("click", e => {
            e.preventDefault();
            const megaNavWrapperLogin = document.querySelector(
                ".login-tooltip"
            );
            const megaNavWrapperContact = document.querySelector(
                ".contact-tooltip"
            );
            const megaNavWrapperAccount = document.querySelector(
                ".meganav-wrapper.account-meganav"
            );
            const megaNavWrapperMain = document.querySelector(
                ".meganav-wrapper.main-nav"
            );
            const megaNavWrapperUniform = document.querySelector(
                ".meganav-wrapper.uniform-meganav"
            );
            const megaNavWrapperMoreinfo = document.querySelector(
                ".meganav-wrapper.more-info-nav"
            );

            if(megaNavWrapperLogin) {
                megaNavWrapperLogin.classList.add("closed");
            }

            megaNavWrapperMain.classList.add("closed");
            megaNavWrapperContact.classList.add("closed");
            megaNavWrapperAccount.classList.add("closed");
            megaNavWrapperMoreinfo.classList.add("closed");

            document.getElementById("uniformMenu").classList.toggle("menu-open");

            megaNavWrapperUniform.classList.toggle("closed");
            if (megaNavWrapperUniform.classList.contains('closed')) {
                menutrigger.classList.remove('active');
            } else {
                menutrigger.classList.add('active');
            }

        });
    }

    const moreinfoMenu = document.getElementById("useful-information");
    if (moreinfoMenu) {
        moreinfoMenu.addEventListener("click", e => {
            e.preventDefault();
            const megaNavWrapperLogin = document.querySelector(
                ".login-tooltip"
            );
            const megaNavWrapperContact = document.querySelector(
                ".contact-tooltip"
            );
            const megaNavWrapperAccount = document.querySelector(
                ".meganav-wrapper.account-meganav"
            );
            const megaNavWrapperMain = document.querySelector(
                ".meganav-wrapper.main-nav"
            );
            const megaNavWrapperUniform = document.querySelector(
                ".meganav-wrapper.uniform-meganav"
            );
            const megaNavWrapperMoreinfo = document.querySelector(
                ".meganav-wrapper.more-info-nav"
            );

            if(megaNavWrapperLogin) {
                megaNavWrapperLogin.classList.add("closed");
            }

            megaNavWrapperMain.classList.add("closed");
            megaNavWrapperContact.classList.add("closed");
            megaNavWrapperAccount.classList.add("closed");
            megaNavWrapperUniform.classList.add("closed");

            megaNavWrapperMoreinfo.classList.toggle("closed");
            if (megaNavWrapperMoreinfo.classList.contains('closed')) {
                menutrigger.classList.remove('active');
            } else {
                menutrigger.classList.add('active');
            }
            document.getElementById("useful-information").classList.toggle("menu-open");


        });
    }

    const activeChild = document.querySelectorAll(".activeChild");
    if (activeChild) {
        activeChild.forEach(el => {
            el.addEventListener("click", e => {
                e.preventDefault();
                const megaNavWrapperLogin = document.querySelector(
                    ".login-tooltip"
                );
                const megaNavWrapperContact = document.querySelector(
                    ".contact-tooltip"
                );
                const megaNavWrapperAccount = document.querySelector(
                    ".meganav-wrapper.account-meganav"
                );
                const megaNavWrapperMain = document.querySelector(
                    ".meganav-wrapper.main-nav"
                );
                const megaNavWrapperUniform = document.querySelector(
                    ".meganav-wrapper.uniform-meganav"
                );
                const megaNavWrapperMoreinfo = document.querySelector(
                    ".meganav-wrapper.more-info-nav"
                );

                if(megaNavWrapperLogin) {
                    megaNavWrapperLogin.classList.add("closed");
                }

                megaNavWrapperMain.classList.add("closed");
                megaNavWrapperContact.classList.add("closed");
                megaNavWrapperAccount.classList.add("closed");
                megaNavWrapperUniform.classList.add("closed");
                megaNavWrapperMoreinfo.classList.add("closed");

                document.getElementById("activeChild").classList.toggle("menu-open");
                menutrigger.classList.add('active');
            });
        });
    }

    const delivery_instructions_check = document.getElementById("delivery_instructions_check");
    if (delivery_instructions_check) {
        delivery_instructions_check.addEventListener("click", e => {


            document.getElementById("instructionsWrapper").classList.toggle("d-none");
        });
    }
    var contactmob =   document.getElementById("openContactMobile");
    if(contactmob != null){
        document.getElementById("openContactMobile")
            .addEventListener("click", e => {
                e.preventDefault();
                const megaNavWrapperLogin = document.querySelector(
                    ".login-tooltip"
                );
                const megaNavWrapperContact = document.querySelector(
                    ".contact-tooltip"
                );
                const megaNavWrapperAccount = document.querySelector(
                    ".meganav-wrapper.account-meganav"
                );
                const megaNavWrapperMain = document.querySelector(
                    ".meganav-wrapper.main-nav"
                );
                const megaNavWrapperUniform = document.querySelector(
                    ".meganav-wrapper.uniform-meganav"
                );
                const megaNavWrapperMoreinfo = document.querySelector(
                    ".meganav-wrapper.more-info-nav"
                );

                if(megaNavWrapperLogin) {
                    megaNavWrapperLogin.classList.add("closed");
                }

                megaNavWrapperMain.classList.add("closed");
                megaNavWrapperAccount.classList.add("closed");
                megaNavWrapperUniform.classList.add("closed");
                megaNavWrapperMoreinfo.classList.add("closed");

                megaNavWrapperContact.classList.toggle("closed");

                if (megaNavWrapperContact.classList.contains('closed')) {
                    menutrigger.classList.remove('active');
                } else {
                    menutrigger.classList.add('active');
                }
            });
    }


    var loginmenu =   document.getElementById("openAccountMobile");
    if(loginmenu != null){
        document.getElementById("openAccountMobile")
            .addEventListener("click", e => {
                e.preventDefault();
                const megaNavWrapperLogin = document.querySelector(
                    ".login-tooltip"
                );
                const megaNavWrapperContact = document.querySelector(
                    ".contact-tooltip"
                );
                const megaNavWrapperAccount = document.querySelector(
                    ".meganav-wrapper.account-meganav"
                );
                const megaNavWrapperMain = document.querySelector(
                    ".meganav-wrapper.main-nav"
                );
                const megaNavWrapperUniform = document.querySelector(
                    ".meganav-wrapper.uniform-meganav"
                );
                const megaNavWrapperMoreinfo = document.querySelector(
                    ".meganav-wrapper.more-info-nav"
                );

                if(megaNavWrapperLogin != null) {
                    megaNavWrapperLogin.classList.remove("closed");
                }
                megaNavWrapperMain.classList.add("closed");
                megaNavWrapperAccount.classList.add("closed");
                megaNavWrapperUniform.classList.add("closed");
                megaNavWrapperMoreinfo.classList.add("closed");

                if (megaNavWrapperContact.classList.contains('closed')) {
                    menutrigger.classList.remove('active');
                } else {
                    menutrigger.classList.add('active');
                }
            });
    }


    const parentToAddTo = document.querySelector(
        '[aria-labelledby="dropdownMenuButtonAccount"]'
    );
    document
        .querySelectorAll(
            "#dropDownMenuButton, #openAccountMobile, #openContactMobile"
        )
        .forEach(el => {
            const cloned = el.cloneNode(true);
            cloned.id = cloned.id + "-clone";
            if (parentToAddTo) {
                parentToAddTo.appendChild(cloned);
            }
        });

    if (parentToAddTo) {
        parentToAddTo.addEventListener("click", () => {
            if (
                !document.querySelector(".mini-basket").classList.contains("d-none")
            ) {
                document.querySelector(".mini-basket").classList.add("d-none");
            }
        });
    }

    // bootstrap tab behaviour - preserve and set active tab
    if (
        window.location.hash &&
        document.querySelector(
            'a[role="tab"][href="' + window.location.hash + '"]'
        ).length > 0
    ) {
        document
            .querySelector(
                'a[role="tab"][href="' + window.location.hash + '"]'
            )
            .show();
    } else {
        const activeTab = localStorage.getItem("activeTab");

        if (activeTab) {
            $('a[role="tab"][href="' + activeTab + '"]').tab('show');
            localStorage.removeItem('activeTab');
        }
    }
    document.querySelectorAll('a[role="tab"]').forEach(el => {
        el.addEventListener("click", () => {
            window.location.hash = el.hash;
            localStorage.setItem("activeTab", el.hash);
        });
    });

    if (menutrigger != undefined) {
        menutrigger.addEventListener('click', function (e) {
            const megaNavWrapperLogin = document.querySelector(
                ".login-tooltip"
            );
            const megaNavWrapperContact = document.querySelector(
                ".contact-tooltip"
            );
            const megaNavWrapperAccount = document.querySelector(
                ".meganav-wrapper.account-meganav"
            );
            const megaNavWrapperMain = document.querySelector(
                ".meganav-wrapper.main-nav"
            );
            const megaNavWrapperUniform = document.querySelector(
                ".meganav-wrapper.uniform-meganav"
            );
            const megaNavWrapperMoreinfo = document.querySelector(
                ".meganav-wrapper.more-info-nav"
            );

            if(megaNavWrapperLogin) {
                megaNavWrapperLogin.classList.add("closed");
            }
            megaNavWrapperMain.classList.add("closed");
            megaNavWrapperAccount.classList.add("closed");
            megaNavWrapperUniform.classList.add("closed");
            megaNavWrapperMoreinfo.classList.add("closed");

            megaNavWrapperContact.classList.add("closed");
            menutrigger.classList.remove('active');
        });
    }


}); // Document ready.

let cardTransitionTime = 500;

let switching = false;

function flipCard(cardId) {
    if (switching) {
        return false;
    }
    switching = true;

    document.querySelector("#" + cardId).classList.toggle("is-switched");
    window.setTimeout(() => {
        document.querySelector("#" + cardId).classList.toggle("is-active");

        switching = false;
    }, cardTransitionTime / 2);
}

// Form validation
(function () {
    "use strict";
    window.addEventListener(
        "load",
        function () {
            // Register form validation - get js-register button
            var registerButton = document.getElementById("js-register");

            if (
                typeof registerButton != "undefined" &&
                registerButton != null
            ) {
                // Get register form
                var registerForm = registerButton.closest("form");

                registerButton.addEventListener("click", function (event) {
                    // Get the hidden address fields by name
                    const elements = document.querySelectorAll(
                        "input[name='company_name'], input[name='address_1'], input[name='address_2'], input[name='city'], input[name='county'], input[name='postcode'], input[name='country_iso2']"
                    );

                    if (registerForm.checkValidity() === false) {
                        // If the form is invalid ensure user can see the address fields
                        elements.forEach(element => {
                            element.parentNode.classList.remove("d-none");
                        });
                    }
                });

                // Disable submit button on form submit event
                registerForm.addEventListener("submit", function (event) {
                    // Check form is valid.
                    if (registerForm.checkValidity()) {
                        registerButton.disabled = true;
                    }
                });
            }

            var elements = document.getElementsByClassName("shippind-method_input");

            var changeDelivery = function (event) {
                var target = event.target;
                var parent = target.parentElement;//parent of "target"

                var lis = document.querySelectorAll('.shipping-method');
                for (var i = 0; i < lis.length; i++) {
                    lis[i].classList.remove('checked');
                }

                parent.classList.add('checked');
            };

            for (var i = 0; i < elements.length; i++) {
                elements[i].addEventListener('change', changeDelivery, false);
            }


            var childCollapse = document.getElementsByClassName("childCollapseOpener");

            var openChildBox = function (event) {
                event.preventDefault();
                var closestChild = event.target.closest('.child');

                if (closestChild) {
                    closestChild.classList.toggle('opened');
                }
            };

            for (var i = 0; i < childCollapse.length; i++) {
                childCollapse[i].addEventListener('click', openChildBox, false);
            }
        },
        false
    );
})();

const tooltips = document.querySelectorAll("[data-tooltip]");

const displayTooltip = (e) => {
    const trigger = e.target;
    const tooltip = trigger.querySelector("[role=tooltip]");

    const {x, y, width, height} = trigger.getBoundingClientRect();
    tooltip.style.left = `${Math.floor(x + width / 2)}px`;
    tooltip.style.top = `${Math.floor(y + height)}px`;

    tooltip.classList.add("active");
};

const hideTooltip = (e) => {
    const tooltip = e.target.querySelector("[role=tooltip]");
    tooltip.classList.remove("active");
};

const DELAY = 300;
let tooltipTimer = null;

tooltips.forEach((trigger) => {
    let tooltip = document.createElement("div");

    tooltip.setAttribute("role", "tooltip");
    tooltip.setAttribute("inert", true);
    tooltip.textContent = trigger.dataset.tooltip;

    trigger.appendChild(tooltip);

    trigger.addEventListener("mouseenter", (e) => {
        clearTimeout(tooltipTimer);

        tooltipTimer = setTimeout(() => {
            displayTooltip(e);
        }, DELAY);
    });

    trigger.addEventListener("mouseleave", (e) => {
        clearTimeout(tooltipTimer);
        hideTooltip(e);
    });
});

/*************** MOBILE MENU ********************/
var mobilemenu = function () {
    //console.log('mobile menu loaded');
    //Menu Toggle
    var mobiletoggle = document.getElementById('burger-menu');
    var mobilemenu = document.getElementById('mob-menu');
    if (mobiletoggle != undefined) {
        mobiletoggle.onclick = function (e) {
            e.target.classList.toggle('open');
            mobilemenu.classList.toggle('open');
            document.body.classList.toggle('modal-open');
        };
    }


    //Mobile Submenu
    var hassubmenu = document.querySelectorAll("#mob-menu .has-megamenu > a ");
    for (var i = 0; i < hassubmenu.length; i++) {
        hassubmenu[i].onclick = function (e) {
            e.preventDefault();
            var el = e.target;
            var showmenu = el.nextElementSibling;
            if (showmenu) {
                //el.classList.toggle('open');
                showmenu.classList.toggle('open');
            }
        };
    }

    //Mobile Submenu Close
    var backbuttons = document.querySelectorAll(".submenu-actions__back");
    for (var i = 0; i < backbuttons.length; i++) {
        backbuttons[i].onclick = function (e) {
            e.preventDefault();
            e.target.closest('.mega-nav').classList.remove('open');
        };
    }

    //Submenu Accordions
    var submenutitles = document.querySelectorAll('.mega-nav__title');
    for (var i = 0; i < submenutitles.length; i++) {
        submenutitles[i].onclick = function (e) {
            var el = e.target;
            el.classList.toggle('open');
            el.nextElementSibling.classList.toggle('open');
        }
    }
};

/*************** MOBILE MENU ********************/
var homepage = function () {
    if (document.querySelector("body")) {
        let scrollpos = window.scrollY;
        const offset = 20;

        const add_class_on_scroll = () => document.querySelector("body").classList.add("scrolled");
        const remove_class_on_scroll = () => document.querySelector("body").classList.remove("scrolled");

        window.addEventListener('scroll', function () {
            scrollpos = window.scrollY;

            if (scrollpos >= offset) {
                add_class_on_scroll()
            } else {
                remove_class_on_scroll()
            }
        });
    }
};

let init = function () {
    mobilemenu();
    homepage();
    filtermenu.init();
    mobilesearch.init();
};
window.onload = function () {
    init();
};

